var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Map/Marker/index.js",
    _this = this;

import React from 'react';
import { Marker as GoogleMapMarker } from '@react-google-maps/api';
import { useTheme } from '../../../core/ThemeProvider';
import { defaultPin } from '../assets/defaultPin';
import { selectedPin } from '../assets/selectedPin';

var Marker = function Marker(_ref) {
  var markerData = _ref.markerData,
      onClick = _ref.onClick,
      showLabel = _ref.showLabel,
      markerLabelClassName = _ref.markerLabelClassName;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var label;

  if (showLabel) {
    label = {
      className: markerLabelClassName,
      text: markerData.name,
      fontSize: theme.map.marker.labelFontSize,
      color: theme.map.marker.labelColor,
      fontFamily: theme.map.marker.labelFontFamily
    };
  }

  var markerIconUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerData.isSelected ? selectedPin : defaultPin);
  var markerLabelOrigin = markerData.isSelected ? new window.google.maps.Point(18, 63) : new window.google.maps.Point(12, 48);
  return /*#__PURE__*/React.createElement(GoogleMapMarker, {
    "data-testid": "google-map-marker",
    onClick: onClick,
    icon: {
      url: markerIconUrl,
      labelOrigin: markerLabelOrigin
    },
    position: markerData,
    label: label,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  });
};

export default Marker;